import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { useApi, oktaAuthApiRef } from '@backstage/core-plugin-api';
import { UserHealthDashboard } from '../../../catalog/group/team/tabs/health/UserHealthDashboard';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8),
    gap: theme.spacing(2),
  },
  loadingText: {
    fontSize: 14,
    color: '#8E9299',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8),
    gap: theme.spacing(2),
  },
  errorText: {
    fontSize: 14,
    color: '#E53E3E',
  },
}));

export const UserProfileHealthContent: React.FC = () => {
  const classes = useStyles();
  const oktaApi = useApi(oktaAuthApiRef);
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profile = await oktaApi.getProfile();
        if (profile?.email) {
          setUserEmail(profile.email);
        } else {
          setError('Unable to determine your email address');
        }
      } catch (err) {
        setError('Failed to load profile information');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [oktaApi]);

  if (loading) {
    return (
      <Box className={classes.loadingContainer}>
        <CircularProgress size={32} />
        <Typography className={classes.loadingText}>Loading your health data...</Typography>
      </Box>
    );
  }

  if (error || !userEmail) {
    return (
      <Box className={classes.errorContainer}>
        <Typography className={classes.errorText}>{error || 'Unable to load profile'}</Typography>
      </Box>
    );
  }

  return (
    <UserHealthDashboard
      weaveEmail={userEmail}
      onBack={() => {}}
      hideBackButton
    />
  );
};
